import { render, staticRenderFns } from "./PricingSchedule.vue?vue&type=template&id=b6cdd6ba&scoped=true"
import script from "./PricingSchedule.vue?vue&type=script&lang=ts"
export * from "./PricingSchedule.vue?vue&type=script&lang=ts"
import style0 from "./PricingSchedule.vue?vue&type=style&index=0&id=b6cdd6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cdd6ba",
  null
  
)

export default component.exports